// Pull one variant's rule out of a typology's serialized `rules` list.
//
// Read-only consumers open this drawer with whatever the alert payload gave them, so the
// typology can be missing entirely (see ScoreExplainability/variantDrawerRecord) and `rules`
// can be absent or non-JSON. Callers only read `result.function[i]`, so an empty function
// list is a safe stand-in — never throw, the drawer must still open.
export function selectRuleById(typology, ruleId) {
  const empty = { function: [] };
  try {
    const rules = JSON.parse(typology?.rules ?? '[]');
    if (!Array.isArray(rules)) return empty;
    return rules.find((r) => r.ruleId === ruleId) || empty;
  } catch {
    return empty;
  }
}
